<div class="content">
  <div class="header modal-header">
    <i class="icon-clear" (click)="cancel()"></i>
    <span>{{ label }}</span>
  </div>
  <div class="main" style="height: 50vh">
    <kgrid
      *ngIf="filterInfo && filterInfo.length > 0"
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      [isMulti]="false"
      [isAdd]="false"
      [isEdit]="false"
      [isDelete]="false"
      [isModal]="false"
      reportName="TresuryList"
      pathPreFix="TRS"
      [disableOnDoubleClick]="true"
      [defaultFilterKey]="filterInfo"
      (onRowSelected)="onRowSelected($event)"
      (onDoubleClick)="onDoubleClick($event)">
    </kgrid>
  </div>

  <div class="footer">
    <button status="success" (click)="submit()" class="btn-ok" ngbAutoFocus>
      <i class="icon-save iconfooter"></i>
      <span>تایید</span>
    </button>

    <button status="danger" (click)="cancel()" class="btn-close">
      <i class="icon-interested iconfooter"></i>
      <span>انصرف</span>
    </button>
  </div>
</div>
